<script>
  // Перенос LevelRing из parts.tsx — монограмма в SVG-дуге прогресса уровня
  // (не conic-gradient: CEF старый, коническими градиентами рисковать нельзя).
  export let initials = '?';
  export let pct = 0;

  const r = 20.5, c = 2 * Math.PI * r;
  $: on = Math.max(0, Math.min(100, pct)) / 100 * c;
</script>

<div class="ring">
  <svg viewBox="0 0 46 46" width="46" height="46">
    <circle cx="23" cy="23" r={r} fill="none" stroke="rgba(255,255,255,0.1)" stroke-width="2.5" />
    <circle
      cx="23" cy="23" r={r} fill="none" stroke="#e0a83e" stroke-width="2.5" stroke-linecap="round"
      stroke-dasharray="{on} {c - on}" style="transition:stroke-dasharray .5s cubic-bezier(.22,.61,.36,1)"
    />
  </svg>
  <div class="mono">{initials}</div>
</div>
